module.exports = __webpack_public_path__ + "static/img/case5.c430d251.jpg";